/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface DayAvailabilityDto
 */
export interface DayAvailabilityDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof DayAvailabilityDto
     */
    day: DayAvailabilityDtoDayEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DayAvailabilityDto
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof DayAvailabilityDto
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof DayAvailabilityDto
     */
    end: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DayAvailabilityDtoDayEnum {
    Monday = 'monday',
    Tuesday = 'tuesday',
    Wednesday = 'wednesday',
    Thursday = 'thursday',
    Friday = 'friday',
    Saturday = 'saturday',
    Sunday = 'sunday'
}

